import React from 'react';

import './styles.scss';

import Ripple from "../Ripple";
import {CircularProgress} from "@material-ui/core";

export const BtnBase = (props) => {
  const {
    className = '',
    children,
    loading,
    disabled,

    heightBig,
    heightMedium,
    square,
    filled,
    outlined,

    ...rest
  } = props

  const isDisabled = disabled || loading;

  const classNamesArr = ['btn'];

  if (heightBig) classNamesArr.push('btn--big');
  if (heightMedium) classNamesArr.push('btn--medium');
  if (square) classNamesArr.push('btn--square');
  if (filled) classNamesArr.push('btn--filled');
  if (outlined) classNamesArr.push('btn--outlined');

  if (disabled) classNamesArr.push('disabled');

  if (className) classNamesArr.push(className);

  return (
    <div className={classNamesArr.join(' ')}>
      <Ripple
        {...rest}
        disabled={isDisabled}
      >
        {loading
          ? (
            <div className="btn__loading-icon">
              <CircularProgress size="2.5rem" color="inherit" />
            </div>
          ) : (
            <div className="btn__content">
              {children}
            </div>
          )
        }
      </Ripple>
    </div>
  )
};

export const btnCtor = ({className = '', ...rest}) => ({className: additionalClassName, ...props}) => (
  <BtnBase
    {...props}
    {...rest}
    className={[className, (additionalClassName || '')].join(' ')}
  />
)
